export default "__VITE_PUBLIC_ASSET__51e69f36__"